import React, { useContext } from "react";
import { Helmet } from "react-helmet";

import { PageContent } from "../core/styles";

import Header from "../components/Header";
import { GET_STORAGE } from "../core/utils";
import { LanguageContext } from "../core/store";
import { useHistory } from "react-router-dom";
import { HOME } from "../core/routes/constants";

const ErrorPage = () => {

    let history = useHistory();

    const { translate } = useContext(LanguageContext);

    const isLogin = GET_STORAGE("is_loggedIn");

    if (!isLogin) {
        history.push(HOME);
    }

    return (
        <>
            <Helmet>
                <title>{translate("metaTags.errorPage.title")}</title>
            </Helmet>

            <Header title={translate("messages.pageNotFound")} />

            <PageContent>
                <p>{translate("messages.pageNotFound")}</p>
            </PageContent>
        </>
    );
};

export default ErrorPage;
